import { i18n } from '@lingui/core';
import { messages as enMessages } from './locales/en/messages.po';

export const locales = {
  en: 'English',
  et: 'Eesti',
  ru: 'Русский',
};

export const defaultLocale = 'en';

/**
 * Get initial locale from URL query parameter or default
 * Reads ?lang= synchronously before React renders to prevent double API calls
 */
export function getInitialLocale(): string {
  if (typeof window === 'undefined') return defaultLocale;

  const params = new URLSearchParams(window.location.search);
  const langParam = params.get('lang');

  if (langParam && (langParam === 'en' || langParam === 'et' || langParam === 'ru')) {
    return langParam;
  }

  return defaultLocale;
}

// Load and activate default locale synchronously
i18n.load(defaultLocale, enMessages);
i18n.activate(defaultLocale);

export async function dynamicActivate(locale: string) {
  if (locale !== defaultLocale) {
    const { messages } = await import(`./locales/${locale}/messages.po`);
    i18n.load(locale, messages);
  }
  i18n.activate(locale);
  document.documentElement.lang = locale;
}

/**
 * Activate the ?lang= locale before the first render.
 * The `t` macro reads the global i18n during render and does not re-render on
 * activate(), so rendering before the catalog loads leaves those strings in English.
 */
export function activateInitialLocale() {
  return dynamicActivate(getInitialLocale());
}

export { i18n };
